'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _creditRequest = require('./credit-request.config');

var _creditRequest2 = _interopRequireDefault(_creditRequest);

var _creditRequest3 = require('./credit-request.component');

var _creditRequest4 = _interopRequireDefault(_creditRequest3);

var _shared = require('./shared/');

var _shared2 = _interopRequireDefault(_shared);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webPublicClient.creditRequest', [_angularUiRouter2.default, _shared2.default.name]).config(_creditRequest2.default).component('creditRequest', _creditRequest4.default);


// WEBPACK FOOTER //
// ./src/credit-request/index.js